import type { Options } from 'ky';

import { getIdentityInstance } from '../schibstedAccount';
import { getCurrentPageViewData } from '../tracking/helpers/pulseOrigin';
import { getCurrentPageData } from '../tracking/pageData';

import { getZuoraParams } from './getZuoraParams';
import type { Salesposter } from './spsApi';
import { spsApi } from './spsApi';

export const enrichSalesposterHtml = async (
  salesposter: Salesposter,
  redirectUrl?: string
) => {
  const { html } = salesposter;

  const { xDomainId } = getCurrentPageViewData();
  const { redirectUri } = await getIdentityInstance();

  const params = new URLSearchParams({
    state: redirectUrl ?? window.location.pathname,
    ...getZuoraParams({
      salesposter,
      pageData: getCurrentPageData(),
      xDomainId,
    }),
  });

  const variables: Record<string, string> = {
    redirect_uri_url_encoded: `${encodeURIComponent(redirectUri)}&${params}`,
    article_id: params.get('content_id') || '',
  };

  const updated = html.replace(
    /{{(\w+)}}/g,
    (_, template) => variables[template] || ''
  );

  return `<base target="_top"> ${updated}`;
};

export type Section = 'default' | 'sport' | 'total' | 'inapp' | 'kjop';

export const fetchSalesposter = async (
  {
    userId,
    entityId,
    section,
  }: {
    userId: string | null;
    entityId: string;
    section: Section;
  },
  options?: Options
) => {
  return spsApi.getSalesposter(
    {
      section,
      placement: 'subscription',
      userId,
      refId: entityId,
    },
    options
  );
};
